/**
 * PGSS-5829: Packing Slip opens /shipments/print-label/{shipment_id}. A row with no shipment yet (an order not on a
 * container) would open /shipments/print-label/undefined, so it offers no Packing Slip.
 */
export function withoutPackingSlipWhenNoShipment(actions, original) {
  if (!actions || original?.shipment_id) return actions;
  return actions.filter((el) => el?.ui_id !== 'PACKING_SLIP');
}
